import { AttachmentModel } from "./attachment.model";

export class AllCaseAttachmentsModel {

    private attachmentsMap = new Map<string, AttachmentModel[]>();

    public static mapAttachments(json: any): AllCaseAttachmentsModel {
        var model = new AllCaseAttachmentsModel();
        if(!json) {
            return model;
        }

        for (const item of json) {
            if(!item.file_name || !item.file_name.indexOf('_')) {
                console.error(`File name missing. Continuing.`);
                continue;
            }
            let index = item.file_name.indexOf('_');
            let type = item.file_name.substring(0, index);
            let attachments: AttachmentModel[] | undefined = model.attachmentsMap.get(type);

            if(!attachments) {
                attachments = [];
                model.attachmentsMap.set(type, attachments);
            }

            attachments.push(item);
        }

        return model;
    }

    public getAttachments(type: string) : AttachmentModel[] {
        let attachments = this.attachmentsMap.get(type);
        
        if(!attachments) {
            return [];
        }

        return attachments;
    }

    public hasAttachmentsForSection(section: string): boolean {
        if(!this.attachmentsMap.has(section)) {
            return false;
        }

        const modelArr: AttachmentModel[] | undefined = this.attachmentsMap.get(section);
        return modelArr !== undefined && modelArr.length > 0;
    }
}
